import { render } from "./TabDetails.vue?vue&type=template&id=268b3822&scoped=true"
import script from "./TabDetails.vue?vue&type=script&lang=ts"
export * from "./TabDetails.vue?vue&type=script&lang=ts"

import "./TabDetails.vue?vue&type=style&index=0&id=268b3822&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-268b3822"

export default script